import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { DateShortcutOption } from '@ui/v2/TableFilter/Chips/FilterChipModalDateRange'

import { currentYear, lastMonth, thisMonth } from '../../../Dashboard/constants/performance'
import { RebateGroupsOptions, useRebateGroupsOptions } from '../../hooks/useRebateGroupsOptions'
import {
  IBTradingAccountsRebatesFilterOptions,
  useIBTradingAccountsRebatesFilterOptions,
} from './useIBTradingAccountsRebatesFilterOptions'

interface IBClientFilterOptions extends RebateGroupsOptions, IBTradingAccountsRebatesFilterOptions {
  signupDateShortcutOptions: DateShortcutOption[]
}

export const useIBClientFilterOptions = (): IBClientFilterOptions => {
  const { t } = useTranslation()

  const ibTradingAccountsRebatesFilterOptions = useIBTradingAccountsRebatesFilterOptions()

  const { rebateApprovalTypes, rebatePeriods } = useRebateGroupsOptions()

  const signupDateShortcutOptions = useMemo<DateShortcutOption[]>(() => {
    return [
      {
        name: t('Calendar.This Month'),
        range: thisMonth,
      },
      {
        name: t('Calendar.Last Month'),
        range: lastMonth,
      },
      {
        name: t('Calendar.Current Year'),
        range: currentYear,
      },
    ]
  }, [t])

  return {
    ...ibTradingAccountsRebatesFilterOptions,
    signupDateShortcutOptions: signupDateShortcutOptions,
    rebateApprovalTypes: rebateApprovalTypes,
    rebatePeriods: rebatePeriods,
  }
}
